module.exports = __webpack_public_path__ + "static/img/dili.8ad92b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mingpian/dili.png
// module id = HxtQ
// module chunks = 0